import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import AppRoutes from './routers/AppRouter';
import { persistor, store } from './store';
import { AuthProvider } from './contexts/AuthContext';
import { CookieProvider } from "./utils/cookie";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import i18n from './locales/i18n';
import { I18nextProvider } from 'react-i18next';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <CookieProvider >
      <Provider store={store} >
        <PersistGate loading={null} persistor={persistor} >
          <ThemeProvider key="theme" theme={theme}>
            <CssBaseline key="css-baseline" />
            <I18nextProvider i18n={i18n}>
              <AuthProvider>
                <AppRoutes />
              </AuthProvider>
            </I18nextProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
      <ToastContainer />
    </CookieProvider>
  );
}

export default App;
